import React from 'react';

const Features = () => {
  const features = [
    {
      icon: 'fa-users',
      title: 'Batch Management',
      description: 'Organize dance classes into batches with easy staff and student assignments. Streamline class organization with automated batch creation and management tools.'
    },
    {
      icon: 'fa-lock',
      title: 'Parent Portal',
      description: 'Secure parent access with default PIN authentication system. Parents get secure access without registration - admin sets default PIN for easy onboarding.'
    },
    {
      icon: 'fa-bell',
      title: 'Fee Reminders',
      description: 'Automated monthly fee notifications sent directly to parents. Never miss fee collection with automated reminder system and notifications.'
    },
    {
      icon: 'fa-money-bill-wave',
      title: 'Program Splitting',
      description: 'Split fees by choreography, costume, makeup, and other criteria. Flexible fee structure allowing parents to pay for specific program components.'
    },
    {
      icon: 'fa-credit-card',
      title: 'Payment Processing',
      description: 'Secure payments directly to dance school bank accounts. Direct payment flow to school accounts with secure processing and approval workflows.'
    },
    {
      icon: 'fa-gift',
      title: 'Zaap Rewards',
      description: 'Earn reward points for dance-related purchases and redemptions. 1000 Zaap coins equals 200 discount on dance-related items within the app.'
    },
    {
      icon: 'fa-cog',
      title: 'Admin Controls',
      description: 'Comprehensive admin panel with approval workflows and settings. Complete administrative control with payment approvals and auto-approve settings.'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Data Security',
      description: 'DPDP Act 2023 compliant data protection and privacy measures. Full compliance with Indian data protection laws ensuring user privacy and security.'
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>Powerful Features for Modern Dance Schools</h2>
          <p>Everything you need to manage fees, batches, and communications in one secure platform</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={`fas ${feature.icon}`}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
